import React from 'react'
import { AiOutlineClose } from 'react-icons/ai'

import { Container, Content, ButtonClose } from './styles'

interface ModalProps {
  onClose(): void
  open: boolean
  hidden?: boolean
}

const Modal: React.FC<ModalProps> = ({ children, onClose, open, hidden }) => {
  window.onclick = function (event: any) {
    if (event.target.id === 'close') onClose()
  }

  return (
    <Container open={open} id="close">
      <Content hidden={hidden}>
        <ButtonClose id="close" onClick={onClose}>
          <AiOutlineClose id="close" size={30} />
        </ButtonClose>
        {children}
      </Content>
    </Container>
  )
}

export default Modal
